import { MealsTypeEnum } from '@repo/utils'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { CarbonFootprintMealTypeFieldProps } from '../CarbonFootprintForm'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../../shadcn/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../shadcn/components/ui/select'

const CarbonFootprintMealTypeField = ({
  form,
}: CarbonFootprintMealTypeFieldProps) => {
  return (
    <FormField
      control={form.control}
      name='mealType'
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel className='font-normal'>
            <FormattedMessage
              id='ui.CarbonFootprintMealTypeField.label'
              defaultMessage='Typologie de repas'
            />
          </FormLabel>
          <FormControl>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <SelectTrigger error={fieldState.error}>
                <SelectValue
                  placeholder={
                    <FormattedMessage
                      id='ui.CarbonFootprintMealTypeField.placeholder'
                      defaultMessage='Sélectionnez'
                    />
                  }
                />
              </SelectTrigger>
              <SelectContent>
                {mealTypeOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      rules={{ required: true }}
    />
  )
}

export default CarbonFootprintMealTypeField

const mealTypeOptions = [
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintMealTypeField.option.varied'
        defaultMessage='Varié'
      />
    ),
    value: MealsTypeEnum.VARIED,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintMealTypeField.option.vegetarian'
        defaultMessage='Principalement végétarien'
      />
    ),
    value: MealsTypeEnum.VEGETARIAN,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintMealTypeField.option.vegan'
        defaultMessage='Principalement vegan'
      />
    ),
    value: MealsTypeEnum.VEGAN,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintMealTypeField.option.redMeat'
        defaultMessage='Principalement viande rouge'
      />
    ),
    value: MealsTypeEnum.RED_MEAT,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintMealTypeField.option.whiteMeat'
        defaultMessage='Principalement viande blanche'
      />
    ),
    value: MealsTypeEnum.WHITE_MEAT,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintMealTypeField.option.fish'
        defaultMessage='Principalement poisson'
      />
    ),
    value: MealsTypeEnum.FISH,
  },
]
